<template>
  <div class="smile-media" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>添加</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column prop="name" label="文件名称"> </el-table-column>
        <el-table-column prop="file_id" label="fileId"> </el-table-column>
        <el-table-column prop="created_at" label="时间"> </el-table-column>
        <el-table-column prop="edit" label="编辑" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加媒体文件' : '修改媒体文件'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item v-if="editType === 'create'" label="mp3文件">
            <el-upload
              ref="upload"
              name="file"
              class="avatar-uploader"
              :action="Mp3UploadAction()"
              :headers="myHeaders"
              :limit="1"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :on-success="handleAvatarSuccess"
              :beforeUpload="beforeAvatarUpload"
            >
              <el-button size="small" type="primary">点击MP3上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="文件名" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createTask"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateTask"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import smileApi from "@/api/smile/index";
import mediaApi from "@/api/smile/media";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: "请输入音乐名", trigger: "blur" }],
      },
      editType: -1,
      editOne: {},
      fileList: [],
      file: "",
      myHeaders: {
        token: ''
      },
    };
  },
  methods: {
    getToken() {
      smileApi.smileToken().then((res) => {
        // console.log('smileToken',res)
        if (res.data.code === 1000) {
          this.myHeaders.token = res.data.accessToken
        }
      });
    },
    Mp3UploadAction() {
      return process.env.VUE_APP_BASE_API+'/api/Smile/uploadFile';
    },
    
    getTableData(pageIndex) {
      // 获取媒体列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      mediaApi.mediaList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
		// console.log('index', index)
      if (index === "create") {
        this.editOne = {
          name: "",
          file_id: "",
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          file_id: index.file_id,
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateTask() {
      mediaApi.mediaAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("更新成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createTask() {
      // console.log("this.editOne", this.editOne);
      mediaApi.mediaAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleAvatarSuccess(res, file) {
      if (res.data.code === 1000 || res.data.code === "1000") {
        this.$message.success("上传成功");
        this.editOne.file_id = res.data.data.fileId;
      } else {
        this.$message.error("错误，" + res.data.message);
      }
    },
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "mp3";
      if (!extension) {
        this.$message({
          message: "上传文件只能是mp3格式！",
          type: "error",
        });
      }
      return extension;
    },
  },
  async mounted() {
    await this.getToken();
    await this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less'>
.smile-media {
  width: 100%;
  .form-info{
    padding-left: 5px;
    .el-form-item__label{
      width:75px;
    }
  }
}
</style>